<template>
  <div class="w-100 h-100 d-flex align-items-center">
    <div class="w-100 h-100 border-bottom p-3 d-flex justify-content-between align-items-center"
      style="position: relative;">
      <div class="d-flex align-items-center">
        <img class="nav-logo-img" src="@/assets/logo.png" />
        <a class="nav-logo-text" href="/">Salework <span style="color: #479a5e">Contact</span></a>
        <el-select v-model="app.globalProcessId" class="ms-3 select-process" v-if="shouldShowSelect"
          placeholder="Chọn quy trình" @change="handleProcessChange">
          <el-option v-for="item in filteredProcessList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <div v-if="app.showNotifyPopover" class="backdrop" @click.self="app.showNotifyPopover = false"></div>
      <div class="d-flex align-items-center">
        <el-tooltip v-if="showSettingOnboarding" content="Hướng dẫn cài đặt nhanh" placement="bottom">
          <div style="position: relative" class="me-3">
            <el-button type="primary" size="small" @click="app.showOnboarding = true" style="border-radius: 6px; font-weight: bold;">
              Cài đặt ngay
            </el-button>
          </div>
        </el-tooltip>
        <!-- Chuông cho cuộc hẹn -->
        <el-tooltip content="Thông báo cuộc hẹn" placement="bottom">
          <div style="position: relative" class="me-2">
            <el-button size="mini" style="border: none" circle @click="showNotifyAppointment">
              <img class="icon-img-large" src="@/assets/icons/notifications.svg" />
            </el-button>
            <span v-if="app.countUnreadNotiAppointment > 0" class="count-notify">
              {{ app.countUnreadNotiAppointment }}
            </span>
          </div>
        </el-tooltip>

        <!-- Chuông thông báo chung -->
        <el-tooltip content="Thông báo hệ thống" placement="bottom">
          <div style="position: relative">
            <el-popover v-model="app.showNotifyPopover" placement="bottom" trigger="manual"
              content="Bạn có thông báo mới" :value="app.countUnreadNoti > 0" popper-class="notify-popover">
              <el-button slot="reference" size="mini" style="border: none" circle @click="showNotify">
                <span class="system-bell-wrap">
                  <img class="icon-img-large" src="@/assets/icons/notifications.svg" />
                  <img class="system-bell-badge" src="@/assets/icons/setting-default.svg" />
                </span>
              </el-button>
            </el-popover>
            <span v-if="app.countUnreadNoti > 0" class="count-notify">
              {{ app.countUnreadNoti }}
            </span>
          </div>
        </el-tooltip>
        <el-button class="ms-1" size="mini" style="border: none" circle @click="toggleBox()">
          <img class="icon-img-large" src="@/assets/icons/menu.svg" />
        </el-button>
        <transition name="fade">
          <div v-show="isBoxVisible" class="menu-box">
            <iframe
              id="app-salework-frame"
              src="https://salework.net/frame/app-salework"
            ></iframe>
          </div>
        </transition>
        <el-tooltip content="Thiết lập tài khoản" placement="bottom">
          <a href="https://salework.net/account" target="_blank">
            <img class="nav-logo-img ms-1" src="@/assets/logo.png" />
          </a>
        </el-tooltip>
      </div>
    </div>
    <Notification v-if="isOpenNotify" :isOpenNotify="isOpenNotify" @closeNoti="isOpenNotify = false" />
    <NotificationAppointment v-if="isOpenNotifyAppointment" :isOpenNotify="isOpenNotifyAppointment"
      @closeNotiAppointment="isOpenNotifyAppointment = false" />
  </div>
</template>

<style scoped>
@import "../../assets/css/navbar.css";
@import "../../scss/index.scss";

.system-bell-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.system-bell-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  padding: 1px;
  box-shadow: 0 0 0 1px #fff;
  pointer-events: none;
}
</style>

<script>
/* eslint-disable */
// import { HTTP } from "@/lib/http-common";
// import workflow from "@/lib/apis/workflow";
import Notification from "../Notification/Notification.vue";
import CreateOrder from "../contact/CreateOrder.vue";
import ContactDetail from "../contact/ContactDetail.vue";
import NotificationAppointment from "../Notification/NotificationAppointment.vue";
export default {
  name: "Navbar",
  components: { Notification, ContactDetail, CreateOrder, NotificationAppointment },
  data() {
    return {
      isOpenNotify: false,
      isOpenNotifyAppointment: false,
      listNotification: [
        {
          id: 1,
          title: "aaaa",
          content: "aaaaaa",
          date: 123847392,
          link: "aaaaa"
        }
      ],
      listUnreadNotification: [],
      expandedGroups: new Set(),
      contactNoti: {},
      showNoticontact: false,
      steps: [],
      selectedProcessId: [],
      processList: [],
      dialogOrder: false,
      loadMore: true,
      isBoxVisible: false,
    };
  },
  computed: {
    showSettingOnboarding() {
      return this.app.user.type == 'ADMIN' || (this.checkPermission("SETTING_FIELD_WRITE") && this.checkPermission("SETTING_WORKFLOW_WRITE"));
    },
    shouldShowSelect() {
      const currentPath = this.$route.path;
      return currentPath === "/contact" || currentPath === "/report" || currentPath ==="/dashboard";
    },
    filteredProcessList() {
    if (this.$route.path === "/dashboard") {
      return this.app.processList.filter(item => item.id !== "all");
    }
    return this.app.processList;
  },
    countUnread() {
      return this.app.countNotification;
    },
  },
  methods: {
    toggleBox() {
      this.isBoxVisible = !this.isBoxVisible;
      if (this.isOpenNotify || this.isOpenNotifyAppointment) {
        this.isOpenNotify = false;
        this.isOpenNotifyAppointment = false;
      }
    },
    toggleExpand(index) {
      const newSet = new Set(this.expandedGroups);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      this.expandedGroups = newSet;
    },
    handleProcessChange() {
      let key = `${this.app.user.id}_${this.app.user.swUsername}`;
      this.setProcessLocalStorage(key, this.app.globalProcessId);
      this.$bus.$emit("changeProcessId");
    },
    async showNotify(event) {
      event.stopPropagation();
      this.isOpenNotify = !this.isOpenNotify;
      if (this.isOpenNotifyAppointment || this.isBoxVisible) {
        this.isOpenNotifyAppointment = false;
        this.isBoxVisible = false;
      }
    },
    async showNotifyAppointment(event) {
      event.stopPropagation();
      this.isOpenNotifyAppointment = !this.isOpenNotifyAppointment;
      if (this.isOpenNotify || this.isBoxVisible) {
        this.isOpenNotify = false;
        this.isBoxVisible = false;
      }
    },
    openDialogOrder() {
      this.dialogOrder = true;
    },
  
    // formatDate(isoString) {
    //   const fixedISOString = isoString.replace(/(\+|\-)\d{4}$/, "Z");
    //   const date = new Date(fixedISOString);

    //   if (isNaN(date.getTime())) {
    //     return "Invalid Date";
    //   }

    //   const options = {
    //     hour: "2-digit",
    //     minute: "2-digit",
    //     day: "2-digit",
    //     month: "2-digit",
    //     year: "numeric",
    //     hour12: false,
    //   };

    //   return new Intl.DateTimeFormat("vi-VN", options).format(date);
    // },
    redirectPage(link) {
      return link;
    },
  },
  mounted() {
    // document.addEventListener("click", this.handleClickOutside);
    // this.$bus.$on("notification", (data) => {
    //   this.handleNotification(data);
    // })
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.beta {
  background-color: royalblue;
  color: white;
  font-size: 10px;
  padding: 2px 3px;
  font-weight: bold;
  border-radius: 4px;
  margin-top: 0.25rem;
}

.select-process>>>input,
i {
  background-color: rgba(10, 88, 192, 0.1);
  color: #0a58c0;
  border: 1px solid rgba(10, 88, 192, 0.4);
}

.notify {
  position: absolute;
  width: 400px;
  max-height: 600px;
  overflow-y: auto;
  right: 10px;
  background: #fff;
  top: 50px;
  z-index: 1111;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  opacity: 0;
  transform: rotateX(-90deg);
  transform-origin: top center;
  transition: opacity 0.3s ease-out;
  animation: rotateMenu 0.3s ease-in forwards;
}

@keyframes rotateMenu {
  0% {
    transform: rotateX(-90deg);
  }

  70% {
    transform: rotateX(10deg);
  }

  100% {
    transform: rotateX(0deg);
  }
}

.notify.show {
  opacity: 1;
}

.notify-item {
  padding: 10px 15px 15px 15px;
  cursor: pointer;
  text-decoration: none;
}

/* .notify-item:hover {
  background: #ced2d6;
  color: #0a58c0;
  font-weight: 600;
} */
.count-notify {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 12px;
  background: #e1002d;
  font-size: 10px;
  padding: 0 8px;
  color: #fff;
  z-index: 9;
}

.btn-conversation {
  height: 30px;
  width: 30px;
}

.img-logo {
  height: 30px;
  width: 30px;
  object-fit: contain;
}

:deep(.el-popover--plain) {
  top: 33px !important;
  right: -78px !important;
  padding: 10px;
  font-weight: 700;
}
/* Hiệu ứng mờ khi hiện/ẩn */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Hộp chứa iframe */
.menu-box {
  position: absolute; /* hoặc fixed nếu bạn muốn overlay toàn trang */
  top: 50px;          /* vị trí so với nút menu */
  right: 10px;
  width: 430px;
  height: 500px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  z-index: 1000;
}

/* Iframe full trong box */
#app-salework-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
